import { X } from "lucide-react";
import { toast } from "sonner";

import { getRecordingQueryKey } from "@/features/recordings/api/get-recording";
import { useOrganisation } from "@/features/select-organisation/api/get-my-organisation";
import { queryClient } from "@/lib/react-query";
import { PublicRecording } from "@classview/shared-types";

import { useRemoveTagFromRecording } from "../api/remove-tag-from-recording";

type RemoveTagFromRecordingProps = {
  recordingId: string;
  tagId: string;
};

export function RemoveTagFromRecording({
  recordingId,
  tagId,
}: RemoveTagFromRecordingProps) {
  const { mutateAsync: removeTagFromRecording } = useRemoveTagFromRecording({
    onSuccess: () => {
      toast.success("Tag removed from recording");
      queryClient.invalidateQueries({
        queryKey: getRecordingQueryKey(organisation.id, recordingId),
      });
    },
    onError: (error) => {
      toast.error(error.message);
    },
    onMutate: (variables) => {
      queryClient.setQueryData(
        getRecordingQueryKey(organisation.id, recordingId),
        (old: PublicRecording) => {
          return {
            ...old,
            tags: old.tags.filter((tag) => tag.id !== variables.tagId),
          };
        },
      );
    },
  });

  const { organisation } = useOrganisation();

  const handleDeleteClick = async (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    event.preventDefault();
    event.stopPropagation();

    await removeTagFromRecording({
      orgId: organisation.id,
      recordingId,
      tagId,
    });
  };

  return (
    <button
      className="h-auto rounded-none p-0 text-secondary hover:bg-transparent hover:text-destructive"
      onClick={handleDeleteClick}
    >
      <X className="size-4" />
    </button>
  );
}
